import React from 'react'
import Grid from '@material-ui/core/Grid'
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ChipField,
  ReferenceField,
  SingleFieldList,
  ArrayField,
  Responsive,
  SimpleList,
  Filter,
  TextInput,
  ReferenceInput,
} from 'react-admin'
import { TableRowList, ListActions } from '../../../components'
import { MatchField, ImageField } from '../../../components/field'
import { MetadataInput, AutocompleteInput } from '../../../components/inputs'
import { getResource } from '../../../config/resources'

const ChannelsFilter = (props) => {
  return (
    <Filter {...props}>
      <Grid container alwaysOn>
        <Grid item xs={12} sm={6} md={4}>
          <TextInput className={props.classes.input} variant="filled" label="Channel" source="channel.name" alwaysOn fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ReferenceInput label="Country" source="country" reference={getResource('transversal', 'countries')} alwaysOn allowEmpty>
            <AutocompleteInput inputValueMatcher={() => null} />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12}>
          <MetadataInput source="metadatas" label="Metadatas" />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Actions = (props) => {
  return <ListActions {...props} filters={<ChannelsFilter />} />
}

export const BroadcastList = (props) => (
  <List bulkActions={false} actions={<Actions />} title="Operadores" {...props}>
    <Responsive
      small={
        <SimpleList
          leftAvatar={(record) => (
            <ReferenceField
              linkType={false}
              basePath={getResource('assets', 'images')}
              record={record}
              label="Image Channel"
              source="channel.image"
              allowEmpty
              reference={getResource('assets', 'images')}
            >
              <ImageField sourceImage="" title="image channel" />
            </ReferenceField>
          )}
          primaryText={(record) => record.channel.name}
          secondaryText={(record) => (
            <ReferenceField
              linkType={false}
              basePath={getResource('competiciones', 'matches')}
              record={record}
              label="Temporada"
              source="match"
              reference={getResource('competiciones', 'matches')}
            >
              <MatchField />
            </ReferenceField>
          )}
        />
      }
      medium={
        <Datagrid>
          <ReferenceField allowEmpty linkType={false} reference={getResource('assets', 'images')} label="Image" source="channel.image">
            <ImageField sourceImage="" title="image channel" />
          </ReferenceField>
          <TextField source="channel.name" label="Name" sortable={false} />
          <ReferenceField label="Game week" source="match" reference={getResource('competiciones', 'matches')}>
            <TextField source="gameweek.name" />
          </ReferenceField>
          <ReferenceField label="Match" source="match" reference={getResource('competiciones', 'matches')}>
            <MatchField />
          </ReferenceField>
          <ArrayField source="channelMatchCountries" label="Countries" sortable={false}>
            <SingleFieldList linkType={false}>
              <ChipField source="country" />
            </SingleFieldList>
          </ArrayField>
          <TableRowList>
            <EditButton />
          </TableRowList>
        </Datagrid>
      }
    />
  </List>
)

export default BroadcastList
